<div class="col-12 col-sm-12">
  <mat-tab-group mat-align-tabs="center">
    <mat-tab label="{{ 'Sellers.Products.Personal' | translate }}">
      <div class="bg-white">
        <div class="border-bottom p-4">
          <h3 class="pt-2">{{ 'Sellers.Products.PersonalInfo' | translate }}</h3>
        </div>
        <form class="border-bottom p-4" *ngIf="basicInfoForm" [formGroup]="basicInfoForm">
          <div class="row justify-content-end">
            <div class="col-12 col-md-6 mb-3">
              <label>{{ 'Sellers.Products.FirstName' | translate }}</label>
              <input class="form-control" type="text" placeholder="{{ 'Sellers.Products.FirstName' | translate }}"
                formControlName="first_name" required />
              <small *ngIf="formValidator?.formErrors?.first_name" class="text-danger">
                {{ formValidator.formErrors.first_name }}
              </small>
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label>{{ 'Sellers.Products.LastName' | translate }}</label>
              <input class="form-control" type="text" placeholder="{{ 'Sellers.Products.LastName' | translate }}"
                formControlName="last_name" required />
              <small *ngIf="formValidator?.formErrors?.last_name" class="text-danger">
                {{ formValidator.formErrors.last_name }}
              </small>
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label>{{ 'Sellers.Products.PhoneNumber' | translate }}</label>
              <div class="input-group">
                <input class="form-control" type="text" placeholder="{{ 'Sellers.Products.PhoneNumber' | translate }}"
                  formControlName="phone" required />
                <div [ngClass]="{ nopadding: !phoneVerified }" class="input-group-append input-verify">
                  <button class="btn text-light m-0 d-block" style="color: white;
                      background-color: rgba(15, 117, 189, 1);
                      height: 100% !important;" *ngIf="!phoneVerified" (click)="sendSMS()">
                    {{ 'Sellers.Products.Verify' | translate }}
                  </button>
                  <div class="mt-1" *ngIf="phoneVerified" fxLayout="row" fxLayoutAlign="center center"
                    style="color: green">
                    <mat-icon>done</mat-icon>
                    <span>{{ 'Sellers.Products.Verified' | translate }}</span>
                  </div>

                </div>
              </div>
              <a *ngIf="phoneVerifyClicked && !phoneVerified" (click)="sendSMS()">{{ 'Sellers.Products.Resend' |
                translate }}</a>
              <small *ngIf="formValidator?.formErrors?.phone" class="text-danger">
                {{ formValidator.formErrors.phone }}
              </small>
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label>{{ 'Sellers.Products.Email' | translate }}</label>
              <div class="input-group">
                <input class="form-control" type="text" placeholder="{{ 'Sellers.Products.Email' | translate }}"
                  formControlName="email" required />
                <div [ngClass]="{ nopadding: !emailVerified }" class="input-group-append input-verify">
                  <button class="btn text-light m-0 d-block" style="color: white;
                          background-color: rgba(15, 117, 189, 1);
                          height: 100% !important;" *ngIf="!emailVerified" (click)="verify_email()">
                    {{ 'Sellers.Products.Verify' | translate }}
                  </button>
                  <div class="mt-1" *ngIf="emailVerified" fxLayout="row" fxLayoutAlign="center center"
                    style="color: green">
                    <mat-icon>done</mat-icon>
                    <span>{{ 'Sellers.Products.Verified' | translate }}</span>
                  </div>
                </div>
              </div>
              <small *ngIf="formValidator?.formErrors?.email" class="text-danger">
                {{ formValidator.formErrors.email }}
              </small>
            </div>
            <div class="col-auto">
              <button class="btn btn-primary" [disabled]="basicInfoForm.invalid" (click)="OnFormSubmit()">
                {{ 'Sellers.Products.Submit' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <app-change-password></app-change-password>
    </mat-tab>
    <mat-tab label="{{ 'Sellers.Products.Business' | translate }}"
      *ngIf="hasUpdateBusinessPermission && !isBranchBusiness">
      <app-business-info></app-business-info>
    </mat-tab>
  </mat-tab-group>
</div>